import {combineReducers} from '@reduxjs/toolkit';

import {mcpLimitLogDataSlice} from './slices/mcp-limit-log-data.slice';
import {mcpLimitLogStateSlice} from './slices/mcp-limit-log-state.slice';

export const mcpLimitLogReducer = combineReducers({
    events: mcpLimitLogDataSlice.reducer,
    state: mcpLimitLogStateSlice.reducer,
});
